import ChemicalRecordsImporter from "./ChemicalRecordsImporter";

export default ChemicalRecordsImporter;
